import { Badge } from '@mantine/core';

type SeverityLevel = 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW';

interface SeverityBadgeProps {
    severity: string;
}

const COLOR_BY_SEVERITY: Record<SeverityLevel, string> = {
    CRITICAL: 'red',
    HIGH: 'orange',
    MEDIUM: 'yellow',
    LOW: 'green',
};

/**
 * Color-coded badge for CVSS severity levels.
 * CRITICAL = red, HIGH = orange, MEDIUM = yellow, LOW = green.
 * Unknown severities fall back to Mantine's neutral `gray`.
 */
export const SeverityBadge = ({ severity }: SeverityBadgeProps): React.JSX.Element => {
    const normalized = severity.toUpperCase();
    const color = COLOR_BY_SEVERITY[normalized as SeverityLevel] ?? 'gray';

    return (
        <Badge color={color} variant="light" data-testid="SeverityBadge">
            {normalized}
        </Badge>
    );
};
